// Zocdoc libraries
import { Breakpoints } from '@zocdoc-frontend-common/styles-grid';
import { getSessionAndTrackingIdsFromCookies } from '@zocdoc-frontend-common/utils-react';
import { isUserExperienceTest } from '@zocdoc-frontend-common/utils-deviceutils';

let injectionPromise;

const branchApiKey =
    process.env.NODE_ENV === 'production'
        ? 'key_live_knlHwBdrd87zfcKk45BCujilAyaUc5iN'
        : 'key_test_kdbRABbCk60EehTd0ZzwFaeoxxoOd3o2';

const defaultOptions = {
    metadata: {
        journey: 'zocdoc',
    },
};

export const getIdsFromCookies = () => {
    const { sessionId, trackingId } = getSessionAndTrackingIdsFromCookies();
    return {
        web_session_id: sessionId,
        web_tracking_id: trackingId,
    };
};

/**
 * An injection singleton for loading the Branch API.
 * We do not want to load more than one copy of the API on the page at once.
 * @return {Promise<null>} resolves when the API has been loaded
 */
export default (initialOptions = {}) =>
    new Promise(resolve => {
        if (window.branch) {
            return resolve();
        } else if (injectionPromise) {
            return injectionPromise.then(resolve);
        }

        let options = initialOptions;
        if (document.documentElement.clientWidth >= Breakpoints.small) {
            options = Object.assign(defaultOptions, initialOptions);
        }

        injectionPromise = new Promise(innerResolve => {
            const initBranch = () => {
                if (!isUserExperienceTest()) {
                    const branchApi = document.createElement('script');
                    branchApi.async = true;
                    branchApi.src =
                        'https://cdn.branch.io/branch-latest.min.js';
                    branchApi.onload = () => {
                        if (window?.branch) {
                            window.branch.init(branchApiKey, options);
                            window.branch.setBranchViewData({
                                data: getIdsFromCookies(),
                            });
                        }

                        innerResolve();
                    };
                    document.body.appendChild(branchApi);
                }
            };

            if (document.readyState === 'complete') {
                setTimeout(initBranch, 0);
            } else {
                window.addEventListener('load', initBranch);
            }
        }).then(resolve);

        return injectionPromise;
    });
